
import React from 'react';

interface KosherIconProps {
  className?: string;
}

export const KosherIcon: React.FC<KosherIconProps> = ({ className = "w-4 h-4" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 111.7 111.7" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#a38e50">
        <path d="m111.1 55.9c0 30.5-24.7 55.2-55.2 55.2s-55.2-24.7-55.2-55.2 24.7-55.3 55.2-55.3 55.2 24.8 55.2 55.3zm-7.5 0c0-26.4-21.4-47.7-47.7-47.7s-47.7 21.3-47.7 47.7 21.4 47.7 47.7 47.7 47.7-21.4 47.7-47.7z"/>
        <path d="m66.3 81.1h25.5l-29-34.3 23.5-15.8h-16.8l-23.3 15.7v-15.7h-19.4v50.1h19.4l.1-23.6z"/>
      </g>
    </svg>
  );
};
